import { useEffect } from 'react';
import useApi from '../../services/useApi';
import styles from './style.module.css';

export default function Callback(){
    useEffect(()=>{
        if(!window.location.hash) return;

        let code = window.location.href.replace(/.*id_token=/, '')
        let url = 'ngp/oauth/resolve/1/' + code

        useApi.get(url).then(async (res) => {
          if (res.status === 200) {
            localStorage.setItem("account",JSON.stringify(res.data));
            window.location.href = '/task-list';
          } else {
            alert('로그인 실패')
          }
        })
        .catch(async (err) => {
            console.log(err)
            alert('서버연결 실패')
        })
    },[])
    return(
    <div className={styles['body']}>
        <span>Welcome&nbsp;&nbsp;to&nbsp;&nbsp;the&nbsp;&nbsp;</span>
        <span>SAMUEL</span> 
    </div>
    )
}